export var DIVIDER_APPEARANCES = {
  regular: 'regular',
  emphasized: 'emphasized'
};
export var DIVIDER_LENGTHS = {
  auto: 'auto',
  fixed: 'fixed',
  fluid: 'fluid'
};